'use client';

import { Icon, TextPassage } from '@petsmart-ui/sparky';

import type { ItemUI } from '@libs/common-node';

import { useOptimizelyFreeShipThreshold } from '../../hooks/useOptimizelyFreeShipThreshold';
import './OptimizelyShipMeter.scss';

type OptimizelyShipMeterProps = {
    autoshipFrequency: number;
    autoshipFrequencyUnitOfMeasure: number;
    previewItem?: Pick<ItemUI, 'id' | 'listPrice' | 'quantity'>;
};

export const OptimizelyShipMeter = ({
    autoshipFrequency,
    autoshipFrequencyUnitOfMeasure,
    previewItem,
}: OptimizelyShipMeterProps) => {
    const shipThreshold = useOptimizelyFreeShipThreshold({
        autoshipFrequency,
        autoshipFrequencyUnitOfMeasure,
        previewItem,
    });

    return Number.parseFloat(shipThreshold) > 0 ? (
        <div className="optimizely-free-ship-meter">
            <Icon name="box-outline" className="optimizely-free-ship-meter__icon" />
            <TextPassage className="optimizely-free-ship-meter__text" data-test-id="optex_pop_sla">
                <span className="optimizely-free-ship-meter__text-threshold">${shipThreshold}</span> away from FREE
                shipping on your future Autoship orders
            </TextPassage>
        </div>
    ) : (
        <div className="optimizely-free-ship-meter">
            <Icon name="box-outline" className="optimizely-free-ship-meter__icon" />
            <TextPassage className="optimizely-free-ship-meter__text" data-test-id="optex_pop_sla">
                You’re getting FREE shipping on your future Autoship orders!
            </TextPassage>
        </div>
    );
};
